import api from '../../../utils/api';

const route = '/team_members';

export const getTeamLandingApi = (params) => api.get(route, { params });
export const getTeamMemberByIdApiLanding = (id) => api.get(`${route}/${id}`);
